import Link from "next/link"
import {IRowData} from '@/lib/types/common-types';
import PipeList from './PipeList';
import StackList from './StackList';
import DataLink from './DataLink';
import {classNames} from '@/lib/utils/commonUtils';
import {titleize} from '@/lib/helper/inflector';
import {faChevronDown, faChevronUp} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {usePathname} from 'next/navigation';

export default function TableRow({
                                     field,
                                     condition,
                                     data,
                                     fieldName,
                                     value,
                                     pipeList,
                                     stackList,
                                     subTable,
                                     subRow,
                                     link,
                                 }: IRowData) {
    const location = usePathname();

    //console.log(field, value, condition);

    switch (field) {
        case "CreationDate" :
        case "LastModificationDate" :
        case "PublicationDate" :
            value = value.split("T")[0];
    }


    return (
        <tr
            className={classNames(
                'data-table-row',
                subTable ? 'mt-1 sub-table-row' : 'border-b  border-slate-100',
                subRow || subTable ? 'sub-row bg-theme-gray-300 bg-opacity-5' : '',
                'grid grid-cols-3',
            )}
        >
            <td className={classNames(subRow ? 'ml-4' : '', 'col-span-3', 'md:col-span-1', 'py-0')}>
                <div className="flex justify-between pe-0 md:pe-4">
                    <span className="md:mr-1 field-name">{titleize(fieldName)}</span>
                    {/** render show less/ show more button if stack list provided  */}
                    {stackList ? (
                        <div className="flex">
                            {stackList.list.length > 1 ? (
                                <>
                                    {location.includes('content')
                                        ?
                                        <button
                                            className="ms-4 border-theme-blue rounded-xl px-2 py-1 text-sm flex items-center"
                                            type="button"
                                            onClick={() => stackList.setOpen(!stackList.open)}
                                        >
                                            <span className="me-3">{`+${stackList.list.length - 1}`}</span>

                                            {stackList.open ? <i className={"mio"}>keyboard_arrow_up</i> :
                                                <i className={"mio"}>keyboard_arrow_down</i>}

                                        </button>
                                        : (
                                            <Link className="text-theme-blue" href={stackList.link}>
                                                {`+${stackList.list.length - 1}`}
                                            </Link>
                                        )}
                                </>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </td>

            <td className="col-span-3 md:col-span-2 md:pl-4 lg:pl-0">
                {/** Render simple value */}
                {value && !link ? <strong>{value}</strong> : null}

                {/** Render simple value */}
                {!value && link ? <DataLink link={link}/> : null}

                {/** Render pipe list if present without stacklist */}
                {pipeList && !stackList ? <PipeList fields={pipeList}/> : null}

                {/** Render open stack list */}
                {!pipeList && stackList && stackList.open ? (
                    <StackList field={field} data={data} items={stackList.list}/>
                ) : null}

                {/** Render closed stack list */}
                {!pipeList && stackList && !stackList.open ? (
                    <StackList field={field} data={data} items={[stackList.list[0]]}/>
                ) : null}
            </td>
        </tr>
    );
}
